import { Injectable } from '@angular/core';
import { UtilsService } from '@ebw-monorepo/utils';
import { ApiUrlService, API_URLS } from 'libs/ng-components/utils/src/lib/services/api-url.service';
import { Observable } from 'rxjs';
import { Fibra } from '../models/fibra.model';

@Injectable({
  providedIn: 'root'
})
export class FibraService {
  constructor(private _apiUrlService: ApiUrlService, private _utilsService: UtilsService) {}

  public getFibra(id: number): Observable<any> {
    let url = `${this._apiUrlService.createUrl(API_URLS.FIBER_JOINTS.FIBER.GET)}?id=${id}`;

    return this._utilsService.getRequest(url, {});
  }

  public updateFibra(data: Fibra): Observable<any> {
    let url = `${this._apiUrlService.createUrl(API_URLS.FIBER_JOINTS.FIBER.UPDATE)}`;

    return this._utilsService.postRequest(url, data, false, {}, 'application/json');
  }
}
